import { render } from "./Terms.vue?vue&type=template&id=2e39136a"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=2e39136a&lang=css"
script.render = render

export default script